import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Divider, Grid, Typography} from '@mui/material';

import {CompanyProfile} from '../types';

import {CompanyProfileMediaImagesCards} from './CompanyProfileMediaImagesCards';
import {CompanyProfileMediaVideos} from './CompanyProfileMediaVideos';
import {ProfileSection} from './ProfileSection';
import {empionOrange} from '../../../../layouts/theme/EmpionColors';

type CompanyProfileMediaProps = {
  company: CompanyProfile;
  updateCompany: (company: CompanyProfile) => void;
};

export const CompanyProfileMedia = ({company, updateCompany}: CompanyProfileMediaProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const {t} = useTranslation();

  return (
    <ProfileSection title={t('companyProfile.header.media.title')} dataTour='profile.media'>
      <Box component='main' sx={{flexGrow: 1}}>
        <CompanyProfileMediaImagesCards
          company={company}
          updateCompany={updateCompany}
          setErrorMessage={setErrorMessage}
        />
        {errorMessage && (
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography sx={{fontSize: 14}} color='error.main' gutterBottom align='center'>
              {errorMessage}
            </Typography>
          </Grid>
        )}
        <Divider
          sx={{
            my: 3,
            height: '1px',
            borderColor: empionOrange[3],
          }}
        />
        <CompanyProfileMediaVideos company={company} />
      </Box>
    </ProfileSection>
  );
};
